import { useSkinMatchIngredients } from "@/hooks/useSkinMatch/useSkinMatch";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { LoadingSpinner } from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import { IngredientDetail } from "../IngredientDetail/IngredientDetail";

type Props = {
  ean: string;
  skinMatchIngredientBaseUrl: string;
  pimProductId: string;
  variantId: string;
  dispatchMonetateImpression: () => void;
};
export function IngredientList({
  ean,
  skinMatchIngredientBaseUrl,
  pimProductId,
  variantId,
  dispatchMonetateImpression,
}: Props) {
  const skinMatchIngredientsData = useSkinMatchIngredients(
    ean,
    skinMatchIngredientBaseUrl,
    pimProductId,
    variantId,
  );

  switch (skinMatchIngredientsData.status) {
    case "No Action":
    case "Error":
      return (
        <Message
          title="Sorry, there's a problem loading the ingredients. Please check back soon."
          type="error"
        />
      );
    case "Loading":
      return <LoadingSpinner />;
    case "Done": {
      const { data } = skinMatchIngredientsData;
      if (data.length === 0) return null;
      dispatchMonetateImpression();
      return <IngredientDetail data={data} />;
    }
    default: {
      return null;
    }
  }
}
